import { c as _c } from "react/compiler-runtime";
import { EmptyPage } from "@components/common/empty-page/empty-page";
import { SelectWorkspaceItem } from "@components/common/workspace/select-workspace-item";
import { MainPageLayout } from "@components/page-layout/main-page-layout";
import { Grid } from "@mui-wrapper";
import { NoWorkspace } from "@pages/workspace/no-workspace";
import { fetchingSdbCompanyFlagsSelector, filteredSdbCompaniesSelector, sdbCompaniesSelector } from "@store/sdb-company/sdb-company-selector";
import { useAppSelector } from "@store/store-helper";
import { Divider, SearchDuoIcon } from "@flat-ui";
import { sortWorkspaces } from "@utils/sdb-company-utils";
import { WorkspaceEvents } from "@utils/track-event/track-event-list";
import { useTrackEvent } from "@utils/track-event/use-track-event";

/** The number of skeletons to show when there are no workspaces.  */
const NUMBER_OF_SKELETONS = 4;

/** Array of skeletons to show when there are no workspaces. */
const skeletonsArray = new Array(NUMBER_OF_SKELETONS).fill(null).map((_, index) => <SelectWorkspaceItem key={`skeleton-${index}`} isEven={index % 2 === 0}
// If no company is provided, it shows an skeleton by default
/>);
export function SelectWorkspacePage() {
  const $ = _c(20);
  const sdbCompanies = useAppSelector(sdbCompaniesSelector);
  const filteredSdbCompanies = useAppSelector(filteredSdbCompaniesSelector);
  const {
    isFetchingSdbCompanies
  } = useAppSelector(fetchingSdbCompanyFlagsSelector);
  const {
    trackEvent
  } = useTrackEvent();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      minHeight: "100vh",
      backgroundColor: "surfaces.secondary",
      position: "relative",
      overflow: "hidden"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      marginTop: "55px"
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== filteredSdbCompanies.length) {
    t2 = filteredSdbCompanies.length > 0 && <Grid sx={{
      color: "text.primary",
      fontSize: "32px",
      fontWeight: "500",
      lineHeight: "44px",
      letterSpacing: "2.5",
      paddingBottom: "32px"
    }} size={12}>All Workspaces<Divider sx={{
        marginTop: "13px"
      }} /></Grid>;
    $[2] = filteredSdbCompanies.length;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== filteredSdbCompanies || $[5] !== trackEvent) {
    t3 = filteredSdbCompanies.length > 0 && filteredSdbCompanies.sort(sortWorkspaces).map((sdbCompany, index) => <SelectWorkspaceItem key={sdbCompany.id} sdbCompany={sdbCompany} isEven={index % 2 === 0} onWorkspaceClick={() => {
      trackEvent({
        name: WorkspaceEvents.selectWorkspace,
        props: {
          numberOfWorkspaces: filteredSdbCompanies.length
        }
      });
    }} />);
    $[4] = filteredSdbCompanies;
    $[5] = trackEvent;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const t4 = filteredSdbCompanies.length === 0 && skeletonsArray;
  let t5;
  if ($[7] !== isFetchingSdbCompanies || $[8] !== sdbCompanies.length) {
    t5 = sdbCompanies.length === 0 && !isFetchingSdbCompanies && <NoWorkspace />;
    $[7] = isFetchingSdbCompanies;
    $[8] = sdbCompanies.length;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== filteredSdbCompanies.length || $[11] !== isFetchingSdbCompanies || $[12] !== sdbCompanies.length) {
    t6 = sdbCompanies.length > 0 && filteredSdbCompanies.length === 0 && !isFetchingSdbCompanies && <Grid sx={{
      position: "fixed",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      zIndex: 10,
      width: "100%",
      paddingTop: {
        xs: "60px",
        sm: "0"
      },
      maxHeight: "100vh",
      overflow: "hidden"
    }} size={12}><EmptyPage title="No results found" subtitle="There are no workspaces that match this search." icon={SearchDuoIcon} /></Grid>;
    $[10] = filteredSdbCompanies.length;
    $[11] = isFetchingSdbCompanies;
    $[12] = sdbCompanies.length;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t2 || $[15] !== t3 || $[16] !== t4 || $[17] !== t5 || $[18] !== t6) {
    t7 = <Grid container={true} sx={t0}><MainPageLayout shouldShowSidebar={false} shouldShowLogo={true} shouldHideOpenButton={true}><Grid container={true} sx={t1}>{t2}{t3}{t4}{t5}{t6}</Grid></MainPageLayout></Grid>;
    $[14] = t2;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  return t7;
}